import { PlanningsDeliveryWithLegRunEntity } from 'src/entities/PlanningsDelivery.entity';

/**
 * 左リストの行 (勤務 × 回転) からコース番号を引くキー。回転はサーバーの cycle
 * (`VehicleRowVM.serverCycle`)。表示用の 1..N (`rotationNumber`) は「回転を追加」や
 * 絞り込みでサーバーの値とずれるので使わない。
 */
export const rotationRowKey = (shiftTruckId: number, cycle: number): string => `${shiftTruckId}:${cycle}`;

/**
 * 勤務一覧の `rotations[].courseNumber` (log_web_issues#352) を行のキーで引ける Map にする。
 * 番号の無い回転 (operation の無い行だけの回転) は載せない。
 */
export function buildCourseNumberByRowKey(
  deliveries: readonly PlanningsDeliveryWithLegRunEntity[],
): ReadonlyMap<string, string> {
  const map = new Map<string, string>();
  deliveries.forEach((delivery) => {
    (delivery.rotations ?? []).forEach((rotation) => {
      if (rotation.courseNumber != null) map.set(rotationRowKey(delivery.id, rotation.cycle), rotation.courseNumber);
    });
  });
  return map;
}
